import { render, staticRenderFns } from "./section.vue?vue&type=template&id=267660d5&scoped=true&"
import script from "./section.ts?vue&type=script&lang=ts&"
export * from "./section.ts?vue&type=script&lang=ts&"
import style0 from "./section.scss?vue&type=style&index=0&id=267660d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267660d5",
  null
  
)

export default component.exports